import React, { useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { BsArrowRight } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { Link } from "react-router-dom";
import TopBanner from "../../components/designTab/TopBanner";
import { courseDetails } from "../../constants";

const SiteMap = () => {
  let [courseTab, setCourseTab] = useState(true);
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Site Map - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Site Map" />
      <div className="max-w-xl py-10 mx-auto">
        <div>
          <ul className="flex flex-col gap-4">
            <Link to="/">
              <li className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group">
                Home
                <span className="text-xl -translate-x-20 group-hover:translate-x-0 transition-transform duration-700">
                  <BsArrowRight />
                </span>
              </li>
            </Link>
            <Link to="/aboutus">
              <li className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group">
                About Us
                <span className="text-xl -translate-x-20 group-hover:translate-x-0 transition-transform duration-700">
                  <BsArrowRight />
                </span>
              </li>
            </Link>
            <Link to="/contactus">
              <li className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group">
                Contact Us
                <span className="text-xl -translate-x-20 group-hover:translate-x-0 transition-transform duration-700">
                  <BsArrowRight />
                </span>
              </li>
            </Link>
            <Link to="/freeseminar">
              <li className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group">
                Free Seminar
                <span className="text-xl -translate-x-20 group-hover:translate-x-0 transition-transform duration-700">
                  <BsArrowRight />
                </span>
              </li>
            </Link>
          </ul>
          <div className="w-full mt-4 border-[1px] border-gray-100 rounded-md">
            <div
              onClick={() => setCourseTab(!courseTab)}
              className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group"
            >
              <h2>Courses</h2>
              {courseTab ? (
                <span className="text-2xl -translate-x-20 text-primeColor rotate-0 transition-rotate duration-300 ">
                  <FiChevronUp />
                </span>
              ) : (
                <span className="text-2xl -translate-x-20 text-primeColor rotate-180 transition-rotate duration-300">
                  <FiChevronUp />
                </span>
              )}
            </div>
            {courseTab && (
              <motion.div
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{
                  delay: 0.2,
                  y: { type: "spring", stiffness: 60 },
                  opacity: { duration: 1 },
                  ease: "easeIn",
                  duration: 0.2,
                }}
                className="w-full px-2"
              >
                <ul className="flex flex-col gap-4 mt-4">
                  {courseDetails.map((course) => (
                    <Link to={course.link}>
                      <li
                        className="bg-gray-100 hover:bg-gray-300 px-4 py-1 rounded-md text-lg font-semibold text-primeColor flex items-center justify-between duration-500 hover:cursor-pointer group"
                        key={course.id}
                      >
                        {course.title}
                        <span className="text-xl -translate-x-20 group-hover:translate-x-0 transition-transform duration-700">
                          <BsArrowRight />
                        </span>
                      </li>
                    </Link>
                  ))}
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteMap;
